import React from 'react';
import { XCircle, AlertTriangle, Calendar, DollarSign } from 'lucide-react';
import { formatarMoeda } from '../utils';
import FinanceStatCards from '../../financeShared/FinanceStatCards';

const HeaderStats = ({ 
  totalVencidas, 
  totalProximas, 
  totalProximosMeses,
  filtroAtivo = 'todas',
  loading = false
}) => {
  // Função para determinar o título do card baseado no filtro
  const getTituloCardProximas = () => {
    switch (filtroAtivo) {
      case 'hoje':
        return 'Vence Hoje';
      case 'recebidas':
        return 'Contas Recebidas';
      case 'proxima_vencimento':
        return 'Próximas 7 Dias';
      default:
        return 'Próximas a Receber';
    }
  };

  const cards = [
    { id: 'vencidas', title: 'Contas Vencidas', value: formatarMoeda(totalVencidas), Icon: XCircle, tone: 'danger' },
    { id: 'proximas', title: getTituloCardProximas(), value: formatarMoeda(totalProximas), Icon: AlertTriangle, tone: 'warning' },
    { id: '3meses', title: 'Próximos 3 Meses', value: formatarMoeda(totalProximosMeses), Icon: Calendar, tone: 'info' },
    { id: 'geral', title: 'Total Geral', value: formatarMoeda(totalVencidas + totalProximas + totalProximosMeses), Icon: DollarSign, tone: 'good' },
  ];

  const cardPrincipal = cards.find((card) => card.id === 'geral') || cards[0];
  const cardsSecundarios = cards.filter((card) => card.id !== cardPrincipal.id);

  const IconPrincipal = cardPrincipal.Icon;

  return (
    <section aria-label="Resumo financeiro de contas a receber" className="space-y-3">
      <div className="md:hidden">
        <article className="rounded-xl border border-[color:var(--cp-border,var(--border))] bg-[linear-gradient(140deg,color-mix(in_srgb,var(--cp-surface-soft,var(--surface-muted))_82%,var(--accent)_18%),color-mix(in_srgb,var(--cp-surface,var(--surface))_90%,transparent))] p-4 shadow-[0_10px_24px_rgba(2,6,23,0.16)]">
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0 flex-1">
              <p className="text-xs font-medium tracking-[0.08em] uppercase text-[color:var(--text-muted)]">
                {cardPrincipal.title}
              </p>
              {loading ? (
                <span className="mt-3 block h-9 w-44 animate-pulse rounded bg-[color:var(--cp-surface,var(--surface))]" />
              ) : (
                <p className="mt-2 text-2xl font-bold leading-tight tracking-tight text-[color:var(--text-primary)] tabular-nums">
                  {cardPrincipal.value}
                </p>
              )}
            </div>
            <span
              className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full border"
              style={{
                color: `var(--status-${cardPrincipal.tone}-fg)`,
                backgroundColor: `var(--status-${cardPrincipal.tone}-bg)`,
                borderColor: `var(--status-${cardPrincipal.tone}-border)`,
              }}
              aria-hidden="true"
            >
              <IconPrincipal className="h-5 w-5" />
            </span>
          </div>
        </article>

        <div className="mt-3 grid grid-cols-1 gap-2.5">
          {cardsSecundarios.map((card) => {
            const IconSecundario = card.Icon;
            return (
              <article
                key={card.id}
                className="rounded-lg border border-[color:var(--cp-border,var(--border))] bg-[color:var(--cp-surface-soft,var(--surface-muted))] p-3.5"
              >
                <div className="flex items-center justify-between gap-3">
                  <div className="min-w-0">
                    <p className="text-[11px] font-medium text-[color:var(--text-muted)]">{card.title}</p>
                    {loading ? (
                      <span className="mt-2 block h-7 w-36 animate-pulse rounded bg-[color:var(--cp-surface,var(--surface))]" />
                    ) : (
                      <p className="mt-1 text-[1.35rem] font-semibold leading-tight text-[color:var(--text-primary)] tabular-nums">
                        {card.value}
                      </p>
                    )}
                  </div>
                  <span
                    className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full border"
                    style={{
                      color: `var(--status-${card.tone}-fg)`,
                      backgroundColor: `var(--status-${card.tone}-bg)`,
                      borderColor: `var(--status-${card.tone}-border)`,
                    }}
                    aria-hidden="true"
                  >
                    <IconSecundario className="h-4 w-4" />
                  </span>
                </div>
              </article>
            );
          })}
        </div>
      </div>

      <div className="hidden md:block">
        <FinanceStatCards cards={cards} loading={loading} ariaLabel="Resumo financeiro de contas a receber" />
      </div>
    </section>
  );
};

export default HeaderStats;
